import React, { useState } from "react";
import Navigation from "../../Components/Navigation/Navigation";
import modalImg from "../../Assets/Images/activities.png";
import Search from "../../Components/Search/Search";
import BackArrow from "../../Components/BackArrow/BackArrow";
import SearchBarResults from "../../Components/Search/SearchBarResults";
import CreateHealthMessage from "../../Components/Modals/CreateHealthMessage";
import HealthMessageTable from "../../Components/Table/HealthMessageTable";

const Health = () => {
  // modal
  const [modalShow, setModalShow] = useState(false);
  // search
  const [search, setSearch] = useState("");
  // active class
  const [activeClass, setActiveClass] = useState("health");

  const activeClassFun = (tab) => {
    setActiveClass(tab);

    const box = document.getElementById("colored_Box");

    if (tab === "activity") {
      box.style.left = "48%";
    } else if (tab === "health") {
      box.style.left = "2%";
    }
  };

  return (
    <div>
      <Navigation />
      <div className="User-Main message_Tabs">
        <BackArrow to="/activities" />
        <div className="User-Div">
          <h3>Health</h3>
          <div className="search-modal">
            <Search SearchValFuc={setSearch} SearchValue={search} />
            <button
              className="create health_Activity"
              variant="primary"
              onClick={() => {
                setModalShow(true);
              }}
            >
              + ADD HEALTH MESSAGE
            </button>
          </div>
          <SearchBarResults SearchValue={search} />
        </div>
        <HealthMessageTable SearchValue={search} />

        {/* <div className="health_activity">
          <div
            className={activeClass === "health" ? "active_Class" : ""}
            onClick={() => activeClassFun("health")}
          >
            HEALTH
          </div>
          <div
            className={activeClass === "activity" ? "active_Class" : ""}
            onClick={() => activeClassFun("activity")}
          >
            ACTIVITY
          </div>
          <div className="colored_Box" id="colored_Box"></div>
        </div> */}
        <CreateHealthMessage
          show={modalShow}
          onHide={() => {
            setModalShow(false);
          }}
          head="Add a new health message"
          detail="You can add the new message here"
          placeholder="Enter message"
          images={modalImg}
        />
      </div>
    </div>
  );
};

export default Health;
